// FAQ accordion
document.querySelectorAll('.faq-item').forEach(item => {
  item.addEventListener('click', () => {
    item.classList.toggle('open');
  });
});

// Mobile nav toggle
const navToggle = document.querySelector('.nav-toggle');
const mobileNav = document.querySelector('.mobile-nav');
if (navToggle && mobileNav) {
  navToggle.addEventListener('click', () => {
    mobileNav.classList.toggle('open');
  });
}

// Email signup form
const signupForm = document.querySelector('.signup-form');
if (signupForm) {
  signupForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const email = signupForm.querySelector('input[type="email"]').value;
    if (email) {
      alert('Thanks for signing up! Check your inbox for a welcome email.');
      signupForm.reset();
    }
  });
  // Make button trigger submit
  const btn = signupForm.querySelector('button');
  if (btn) {
    btn.addEventListener('click', () => signupForm.dispatchEvent(new Event('submit')));
  }
}
